"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.actions = void 0;
exports.default = createReducerManager;
Object.defineProperty(exports, "reducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});
exports.selectors = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _redux = require("redux");
var actions = _interopRequireWildcard(require("./actions"));
exports.actions = actions;
var selectors = _interopRequireWildcard(require("./selectors"));
exports.selectors = selectors;
var _reducer = _interopRequireDefault(require("./reducer"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createReducerManager(initialReducers) {
  var reducers = _objectSpread({}, initialReducers);
  var combinedReducer = (0, _redux.combineReducers)(reducers);
  var keysToRemove = [];
  var remove = function remove(key) {
    if (!key || !reducers[key]) {
      return;
    }
    delete reducers[key];
    keysToRemove.push(key);
  };
  var reduce = function reduce(state, action) {
    var newState = state;
    if (keysToRemove.length > 0) {
      newState = _objectSpread({}, state);

      // eslint-disable-next-line no-restricted-syntax
      for (var _i = 0, _keysToRemove = keysToRemove; _i < _keysToRemove.length; _i++) {
        var key = _keysToRemove[_i];
        delete newState[key];
      }
      keysToRemove = [];
    }
    return combinedReducer(newState, action);
  };
  var load = function load(typeReducers) {
    Object.keys(reducers).forEach(function (reducerKey) {
      if (!initialReducers[reducerKey]) {
        remove(reducerKey);
      }
    });
    if (!typeReducers) {
      combinedReducer = (0, _redux.combineReducers)(reducers);
      return;
    }
    Object.keys(typeReducers).forEach(function (reducerKey) {
      reducers[reducerKey] = typeReducers[reducerKey];
    });
    combinedReducer = (0, _redux.combineReducers)(reducers);
  };
  return {
    reduce: reduce,
    load: load
  };
}
//# sourceMappingURL=index.js.map